import { AnyAction, Reducer } from 'redux';
import { createReducer } from 'reduxsauce';

import { OfwcaPathTypes } from './ofwcaPath.actions';
import { initState } from './ofwcaPath.state';
import { State } from './ofwcaPath.types';

const setFields: Reducer = (state: State, { fields }: AnyAction): State => ({
  ...state,
  fields,
});

const setShouldRefreshConfirmation: Reducer = (state: State, { shouldRefreshConfirmation }: AnyAction): State => ({
  ...state,
  fields: {
    ...state.fields,
    shouldRefreshConfirmation,
  },
});

const setRelatedStations: Reducer = (state: State, { relatedStations }: AnyAction): State => ({
  ...state,
  relatedStations,
});

const setSignedDocuments: Reducer = (state: State, { signedDocuments }: AnyAction): State => ({
  ...state,
  signedDocuments,
});

const clearData: Reducer = (state: State): State => ({
  ...state,
  fields: null,
  relatedStations: null,
  signedDocuments: null,
});

const setFormStatus: Reducer = (state: State, { formStage }: AnyAction): State => ({
  ...state,
  fields: {
    ...state.fields,
    formStage,
  },
});

export const reducer: Reducer = createReducer(initState, {
  [OfwcaPathTypes.SET_FIELDS]: setFields,
  [OfwcaPathTypes.SET_FORM_STAGE]: setFormStatus,
  [OfwcaPathTypes.SET_RELATED_STATIONS]: setRelatedStations,
  [OfwcaPathTypes.SET_SIGNED_DOCUMENTS]: setSignedDocuments,
  [OfwcaPathTypes.SET_SHOULD_REFRESH_CONFIRMATION]: setShouldRefreshConfirmation,
  [OfwcaPathTypes.CLEAR_DATA]: clearData,
});
